var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2690_38004)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2690_38004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 54.6665C131.316 54.6665 142.168 59.1617 150.17 67.1633C158.172 75.1648 162.667 86.0173 162.667 97.3332C162.667 108.649 158.172 119.502 150.17 127.503C142.168 135.505 131.316 140 120 140C108.684 140 97.8317 135.505 89.8302 127.503C81.8286 119.502 77.3334 108.649 77.3334 97.3332C77.3334 86.0173 81.8286 75.1648 89.8302 67.1633C97.8317 59.1617 108.684 54.6665 120 54.6665ZM120 161.333C167.147 161.333 205.333 180.427 205.333 204V277.5H34.6667V204C34.6667 180.427 72.8534 161.333 120 161.333Z",
    fill: "#F25858"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2690_38004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    rx: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2690_38004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white",
    transform: "translate(-8 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.5354bd76d62c976d7f1b6d1c8fe94ee1.svg";
export { ForwardRef as ReactComponent };